import type { QueueItem } from "../../hooks/useUploadQueue.js";

function formatSize(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}

export function UploadProgressItem({
  item,
  onRetry,
  onRemove,
}: {
  item: QueueItem;
  onRetry: (id: string) => void;
  onRemove: (id: string) => void;
}) {
  return (
    <div
      className="card"
      style={{ padding: "var(--space-3) var(--space-4)", display: "flex", alignItems: "center", gap: "var(--space-3)" }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, color: "var(--color-text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {item.file.name}
        </p>
        <p style={{ margin: 0, fontSize: "0.8rem" }}>{formatSize(item.file.size)}</p>

        {item.status === "uploading" && (
          <div
            style={{
              marginTop: 6,
              height: 6,
              borderRadius: 999,
              background: "var(--color-border)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${Math.round(item.progress * 100)}%`,
                height: "100%",
                background: "var(--color-primary)",
                transition: "width 0.15s ease",
              }}
            />
          </div>
        )}

        {item.status === "error" && <p className="error-text" style={{ marginTop: 4 }}>{item.error}</p>}
      </div>

      {item.status === "done" && <span className="badge badge-success">Envoyé</span>}
      {item.status === "uploading" && <span className="badge">{Math.round(item.progress * 100)}%</span>}
      {item.status === "pending" && <span className="badge">En attente</span>}
      {item.status === "error" && (
        <button type="button" className="btn btn-secondary" onClick={() => onRetry(item.id)}>
          Réessayer
        </button>
      )}
      {item.status !== "uploading" && (
        <button
          type="button"
          aria-label="Retirer"
          onClick={() => onRemove(item.id)}
          className="btn btn-secondary"
          style={{ padding: "0 var(--space-3)" }}
        >
          ✕
        </button>
      )}
    </div>
  );
}
